<section class="container">
    <section class="dialog-content-container">
    <section class="heading-container" *ngIf="showCloseIcon">
        <i class="pi pi-times icon" (click)="done()"></i>
    </section>
    <section class="content-container">
        <label class="title">{{'PARENT_PORTAL.ONBOARDING.INVITATION_APP.MODAL.TITLE' | translate }}</label>
        <picture class="image-container">
            <img class="image-element" [ngSrc]="'qr_download_app_modak.webp' | staticServe" width="128" height="128" alt="qr" />
        </picture>
    </section>
    </section>
    <section class="button-container">
        <mdk-btn
        class="done-button"
        [buttonText]="'PARENT_PORTAL.ONBOARDING.INVITATION_APP.MODAL.DONE' | translate"
        (buttonClick)="done()" />
    </section>
</section>

